export const iconFontAwesomeCharityHandshakeSimple = (
	<i className="fa-solid fa-handshake-simple"></i>
);
